import { createContext, useState, useCallback } from 'react';

interface IMobileNavContext {
  mobileOpen: boolean;
  toggleMobileNav: () => void;
  closeMobileNav: () => void;
}

export const MobileNavContext = createContext<IMobileNavContext>({
  mobileOpen: false,
  toggleMobileNav: () => {},
  closeMobileNav: () => {},
});

export const MobileNavProvider = ({ children }: { children: React.ReactNode }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleMobileNav = useCallback(() => {
    setMobileOpen((prev) => !prev);
  }, []);

  const closeMobileNav = useCallback(() => {
    setMobileOpen(false);
  }, []);

  return (
    <MobileNavContext.Provider value={{ mobileOpen, toggleMobileNav, closeMobileNav }}>
      {children}
    </MobileNavContext.Provider>
  );
};
